/** A fresh running cave from a built one (docs/spec/02). */

import { E } from './elements';
import { Rng } from './rng';
import { RULES } from './tuning';
import type { CaveSetup, CaveState } from './types';

export function createCave(setup: CaveSetup, seed: number): CaveState {
  const { w, h, params } = setup;
  const cells = Uint8Array.from(setup.cells);
  let ix = 0;
  let iy = 0;
  const inbox = cells.indexOf(E.INBOX);
  if (inbox >= 0) {
    ix = inbox % w;
    iy = Math.floor(inbox / w);
  }
  const gateOpen = params.diamondsNeeded <= 0;
  if (gateOpen) {
    for (let i = 0; i < cells.length; i++) if (cells[i] === E.OUTBOX_CLOSED) cells[i] = E.OUTBOX_OPEN;
  }
  return {
    w,
    h,
    cells,
    stamp: new Uint32Array(w * h),
    moved: new Uint8Array(w * h),
    params,
    rng: new Rng(seed),
    seed,
    scan: 0,
    ms: 0,
    bornMs: -1,
    hatchScan: Math.max(1, Math.ceil(RULES.hatchMs / Math.max(1, params.tickMs))),
    timeLeft: params.time,
    secondMs: 0,
    diamonds: 0,
    score: 0,
    gateOpen,
    status: 'playing',
    digby: { x: ix, y: iy, born: false, alive: true, facing: 1, moving: false, pushing: false, idle: 0 },
    amoeba: { phase: 'sleeping', size: 0, growing: false, count: 0, canGrow: false },
    magic: { phase: 'dormant', msLeft: 0 },
    keys: [false, false, false],
    events: [],
  };
}
